import { createContext, useContext } from 'react';

/** @todo: Integrate into `ClientContext` */
export const MetaInformationContext = createContext<unknown>(undefined);

export const useMetaInformationProps = () => {
  const context = useContext(MetaInformationContext);

  if (context === undefined) {
    throw new Error(
      'useMetaIntormationProps must be used within a MetaInformationContext.Provider',
    );
  }

  return context;
};
